import { Button } from "../components/ui/button";
import { Phone, Mail } from "lucide-react";
import { motion } from "motion/react";
import React from "react";

export default function Support() {
  const services = [
    { id: 'farm-development', title: 'Farm Development' },
    { id: 'precision-agriculture', title: 'Precision Agriculture' },
    { id: 'irrigation-solutions', title: 'Irrigation Solutions' },
    { id: 'soil-testing', title: 'Soil Testing' },
    { id: 'digital-farming', title: 'Digital Farming' },
    { id: 'equipment-supply', title: 'Equipment Supply' }
  ];

  const openService = (id: string) => {
    // If not on the homepage, navigate there with hash (will reload). Also dispatch event shortly after.
    if (window.location.pathname !== '/') {
      window.location.href = `/#${id}`;
      setTimeout(() => window.dispatchEvent(new CustomEvent('openService', { detail: { id } })), 700);
    } else {
      window.location.hash = `#${id}`;
      window.dispatchEvent(new CustomEvent('openService', { detail: { id } }));
    }
  };
  return (
    <main className="min-h-screen bg-gradient-to-b from-white via-[#DAF1DE]/20 to-white flex items-center justify-center p-8">
      <motion.div
        className="max-w-3xl w-full bg-white p-12 rounded-3xl shadow-2xl border-2 border-[#8EB69B]/20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-4xl text-[#051F20] mb-4">Support & Quote</h1>
        <p className="text-[#163832] mb-6">
          Need immediate assistance or a detailed quote? Contact our support team and we'll respond within 24 hours.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <a href="tel:+918147851696" className="flex items-center gap-3 p-4 rounded-xl border border-[#DAF1DE] hover:bg-[#DAF1DE]/40">
            <Phone className="h-6 w-6 text-[#235347]" />
            <div>
              <div className="text-sm text-[#051F20]">Call Us</div>
              <div className="text-sm text-[#163832]">+91 81478 51696</div>
            </div>
          </a>

          <a href="mailto:info@kalpakrushi.com" className="flex items-center gap-3 p-4 rounded-xl border border-[#DAF1DE] hover:bg-[#DAF1DE]/40">
            <Mail className="h-6 w-6 text-[#235347]" />
            <div>
              <div className="text-sm text-[#051F20]">Email</div>
              <div className="text-sm text-[#163832]">info@kalpakrushi.com</div>
            </div>
          </a>
        </div>

        <div className="mb-6">
          <h2 className="text-2xl text-[#051F20] mb-3">Our Services</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {services.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => openService(s.id)}
                  className="w-full text-left p-4 rounded-xl border border-[#DAF1DE] hover:bg-[#DAF1DE]/40"
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-4">
          <Button asChild>
            <a href="mailto:info@kalpakrushi.com?subject=Request%20for%20Quote">Request a Quote</a>
          </Button>
          <Button variant="ghost" asChild>
            <a href="/">Back to Home</a>
          </Button>
        </div>
      </motion.div>
    </main>
  );
}
